import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  const { t } = useLanguage();

  const links = [
    { to: "/", label: t("nav.home") },
    { to: "/about", label: t("nav.about") },
    { to: "/services", label: t("nav.services") },
    { to: "/home-health", label: t("nav.home_health") },
    { to: "/lifestyle", label: t("nav.lifestyle") },
    { to: "/contact", label: t("nav.contact") },
  ];

  return (
    <footer data-testid="main-footer" className="bg-[#1E2922] text-white/80">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <h3 className="font-heading text-2xl font-semibold text-white mb-4">
              Dr. Burcu Varol
            </h3>
            <p className="text-sm leading-relaxed text-white/60">
              {t("footer.description")}
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] font-semibold text-[#C9A988] mb-6">
              {t("footer.quick_links")}
            </h4>
            <ul className="space-y-3">
              {links.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    data-testid={`footer-link-${link.to.replace("/", "") || "home"}`}
                    className="text-sm text-white/60 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact info */}
          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] font-semibold text-[#C9A988] mb-6">
              {t("footer.contact_info")}
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-[#C9A988] mt-0.5 shrink-0" />
                <span className="text-sm text-white/60">
                  {t("contact.info.address")}
                </span>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-[#C9A988] mt-0.5 shrink-0" />
                <span className="text-sm text-white/60">
                  {t("contact.info.phone")}
                </span>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="text-[#C9A988] mt-0.5 shrink-0" />
                <span className="text-sm text-white/60">
                  {t("contact.info.email")}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 text-center">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} Dr. Burcu Varol. {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
}
